import React from 'react';
import PropTypes from 'prop-types';
import TopNewsSection from './Featured/TopNewsSection';

const ArticleLayout = ({
  featuredVariables,
  moreNewsVariables,
  categorySection,
  wfbAds,
  showCreatedAt,
  expandedSections,
}) => (
  <TopNewsSection
    variables={featuredVariables}
    moreNewsVariables={moreNewsVariables}
    showCreatedAt={showCreatedAt}
    expandedSections={expandedSections}
    categorySection={categorySection}
    wfbAds={wfbAds}
  />
);

ArticleLayout.propTypes = {
  featuredVariables: PropTypes.shape({}),
  moreNewsVariables: PropTypes.shape({}),
  categorySection: PropTypes.node,
  wfbAds: PropTypes.node,
  showCreatedAt: PropTypes.bool,
  expandedSections: PropTypes.bool,
};

ArticleLayout.defaultProps = {
  featuredVariables: null,
  moreNewsVariables: null,
  categorySection: null,
  wfbAds: null,
  showCreatedAt: false,
  expandedSections: false,
};

export default ArticleLayout;
